module.exports = __webpack_public_path__ + "static/media/bacalhau8045.1d268ade.webp";